// DRINKS PWA FRONTEND
<template>
    <div  class="drinkmain">
<!-- /* Logged In Business user */ -->
        <div  v-if="$store.getters.user && $user.userType=='business' ">

            <AppBar />
        </div>

<!-- ###################### LEFT SIDE MENU SLIDE OUT MENU SETTINGS ###################### -->
<!-- /* Business Dashboard */ -->
<!-- Logged in Business Side Drawer Menu  -->


<!-- Logged in Business Side Drawer Menu -->

        <v-overlay v-model="itemoverlayPlain"  z-index="99999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
<!-- Spinner settings  -->
        </v-overlay>
   <!-- <v-overlay v-model="orderoverlay" z-index="99999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>

        </v-overlay>

        <v-overlay v-model="overlayfooditemimageupdate" z-index="99999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>

        </v-overlay> -->


        <!-- <v-overlay v-model="overlayPIN" >
            ########## This was commented out previously ###########<v-progress-circular indeterminate size="64"></v-progress-circular>############
            <img :src="cocacolaImg" style="height:250px;max-width:auto !important;display:inline !important;"/>
        </v-overlay> -->

<!-- ##################### TOP LOGO AND ALLERGEN ICON TOP RIGHT FOOD MENU ##################### -->

<!-- ##################### FOOD PAGE TOP LOGO AND ALLERGEN ICON ##################### -->


        <v-card  class="pb-80" elevation=0 v-if="isloaded">
                    <div class="pa-0">
                        <v-row class="ma-0 business-logo-top-center">
                            <v-col cols="12" v-if="business.logo=='null' || business.logo=='null'">
                                <h2> {{business.businessName}}</h2>
                            </v-col>
                            <v-col cols="12" v-else>
                                <img :src="business.logo" class="business-logo-top-center" :alt="business.businessName"/>
                            </v-col>
                            <!-- <v-col cols="2">
                                <v-row>
                                    <span class="text-center">
                                        <a @click="filterAllergens=!filterAllergens">
                                            <v-row>
                                                <img :src="allergenImg"  class="pulsex7 allergen-filter-icon">
                                            </v-row>
                                            <v-row class="allergen-filter-icon-label">
                                                {{$t('zz_allergens')}}
                                            </v-row>
                                        </a>
                                    </span>
                                </v-row>
                            </v-col> -->
                        </v-row>
                    </div>


            <v-card-text class="pt-0 pb-0 pl-2 pr-2 mb-0 mt-5" >
<!-- /* Filter for Allergens */ -->
                <div v-if="!filter && !filterAllergens">
                    <!-- Drink Type Tabs -->
                    <v-tabs height="32" :color= business.themecolor background-color="#fff" center-active show-arrows class="">
                        <v-tab  v-for="(item, index) in business.ditems" :key="index"  class=""  @change="$redrawVueMasonry()">
                         {{ index }}
                        </v-tab>

<!-- Sticky Nav Bar Grid/List Icons & Favorites Counter -->

                        <v-tab-item v-for="(item, index) in business.ditems" :key="index" class="pa-1" sticky-container>
                            <v-row  align="center" v-sticky style="background:#d4d4d4;" class="mb-3">
                                <v-col cols="6" class="">
                                    <div class="fixed-course-heading">
                                        {{ index }}
                                    </div>
                                </v-col>


                                <v-col cols="2" class="mid-mid" v-if=" countActivelang==1">
                                        <!-- <v-icon v-if="foodview=='list'"
                                                class="grid-list-icons" @click="setview('grid','foodgrid-'+item[0].course_id)"
                                                color="#FE5800"
                                                size="18">mdi-grid-large
                                        </v-icon>
                                        <v-icon v-if="foodview=='grid'" class="grid-list-icons" @click="setview('list','foodgrid-'+item[0].course_id)"
                                            color="#FE5800"
                                            size="18">mdi-format-list-bulleted-square
                                        </v-icon> -->
                                        <v-menu class="" @click.native.stop  transition="fab-transition" v-if="business.hastranslations">
                                            <template v-slot:activator="{ on, attrs }"
                                            top
                                            left
                                            transition="scale-transition"
                                            >
                                                <v-btn @click.stop color="#FE5800" icon v-bind="attrs" v-on="on">
                                                    <v-avatar size="24" tile>
                                                        <img :src="'https://api.juzzap.com/flags/4x3/'+userlangcode+'.svg'" />
                                                    </v-avatar>

                                                </v-btn>
                                            </template>

                                            <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                                <v-list-item v-for="(lang,ind) in business.translationlanguages" :key="'tl-'+ind">
                                                    <a @click.prevent="setlangcode(lang.languagecode)">
                                                        <div class="row">
                                                        <div class="col-3"><img :src="lang.photo"  :alt="lang.languagecode" width="16"/></div>
                                                        <div class="col-9">{{lang.lname+'('+lang.languagecode+')'}}</div>
                                                    </div>
                                                    </a>

                                                </v-list-item>



                                            </v-list>
                                        </v-menu>
                                </v-col>
                                <v-col cols="2" class="mid-mid">
                                    <span class="text-center">
                                        <a @click="filterAllergens=!filterAllergens">
                                            <v-row>
                                                <img :src="allergenImg"  class="pulsex7 allergen-filter-icon">
                                            </v-row>
                                            <!-- <v-row class="allergen-filter-icon-label">
                                                {{$t('zz_allergens')}}
                                            </v-row> -->
                                        </a>
                                    </span>
                                </v-col>
                                <v-col cols="2" class="mid-mid">
                                    <v-row
                                        color=""
                                        class=""
                                        @click="gotoorder">
                                        <v-avatar class="favorite">
                                            <span :class="[showcard?'favorite-count-cart':'favorite-count-heart']">
                                            <!-- <span class="favorite-count"> -->
                                                {{order.items.length}}
                                            </span>
                                            <v-icon class="favorite" color="#fe5800" size="30" style="font-size:30" v-if="showcard==1">mdi-cart</v-icon>
                                            <v-icon class="favorite" color="#fe5800" size="30" style="font-size:30" v-else-if="showcard==0">mdi-heart</v-icon>
                                        </v-avatar>
                                        <!-- {{$t('zz_order')}} -->
                                    </v-row>
                                </v-col>

                            </v-row>



                            <v-row v-if="business.typemaster[index].description!=''  &&  business.typemaster[index].description!=null &&  business.typemaster[index].description!='null'" class="food-course-top-banner" tile>
                                <v-col col="12" md="12" class="food-course-top-banner-description text-center">
                                    <!-- <span v-html="business.coursesmaster[index].price"></span> -->
                                    <span v-html="business.typemaster[index].description"></span>

                                </v-col>
                            </v-row>


<!-- ######################  ? GRID VIEW SECTION  ###################### -->
                            <!-- <v-row  item-selector=".grid-item-container">
                                <div v-for="(item, index) in business.drinkitems" :key="index"
                                class="pa-3  col-6 col-md-3 grid-item-container"  v-masonry="'foodgrid'+index" transition-duration="0.3s" sticky-container> -->

                                    <v-row
                                    v-if="foodview=='grid'" :id="'drinkgrid'+index.replace(' ','-').toLowerCase()"
                                    class="pa-0 ma-0 grid row" :v-masonry="'drinkgrid'+index.replace(' ','-').toLowerCase()" transition-duration="1s" item-selector=".grid-item" >

                                        <div v-for="(drink, ind) in item" :key="ind"
                                        class="pa-3 foodgriditem grid-item">

                                            <v-card
                                            tile
                                            class="mx-auto cardborder pb-3 ma-1"
                                            :class="drink.separation? 'section-heading-grid':''"
                                            max-width="100%"
                                            @click.stop="drinkitemdetails(drink.id,'','drink',drink.separation)"
                                            >
                                                <v-img
                                                :src="drink.fimage"
                                                contain
                                                class="drinkimg"
                                                height="250px"
                                                max-width="100%"
                                                style="position:relative"
                                                >

                                                </v-img>
<!-- COGS - DROPDOWN MENU GRID VIEW -->
                                                <v-row class="pl-2 pr-3" justify="space-between" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                            <v-col class="pa-0 pl-2">
                                                                    <v-menu @click.native.stop transition="fab-transition">
                                                                        <template v-slot:activator="{ on, attrs }"
                                                                        bottom
                                                                        right
                                                                        transition="scale-transition"
                                                                        >

                                                                        <v-btn @click.stop float-right color="primary" icon v-bind="attrs" v-on="on">
                                                                            <!-- <v-icon>fa fa-cog fa-spin</v-icon> -->
                                                                            <v-icon>fa fa-cogs</v-icon>
                                                                        </v-btn>
                                                                        </template>
                                                                        <v-icon color="red" icon small dark class="close-menu pa-0 ma-0 pt-2 pr-2">mdi-close-circle</v-icon>
                                                                            <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                                                            <v-list-item>
                                                                                <span class="mt-4 edit-item-name">{{drink.name}}</span>
                                                                            </v-list-item>

                                                                        <!-- <v-list class="pt-0 text-center">
                                                                            <v-list-item>
                                                                                <v-btn color="red" icon x-small dark class="close-menu pa-0 ma-0">
                                                                                    <v-icon>mdi-close-circle</v-icon>
                                                                                </v-btn>
                                                                            </v-list-item> -->
                                                                            <v-list-item>
                                                                                <div class="mt-0 pl-0 pr-0 d-flex" v-if="item.showonmenu==1">
                                                                                <v-switch no-gutters style="font-size:12px !important;" color="success" :input-value="shw"  @click.stop="updateshowitem(item.item.id,item.course_id,0)" :id="'showonitem-'+item.id"></v-switch>
                                                                            </div>
                                                                            <div class="d-flex" v-else>
                                                                                <v-switch no-gutters style="font-size:12px !important;" color="" :input-value="nshw"  @click.stop="updateshowitem(item.item.id,item.course_id,1)" :id="'showonitem-'+item.id"></v-switch>
                                                                            </div>
                                                                            </v-list-item>
                                                                            <v-list-item>
                                                                                <v-btn icon @click.prevent="drinkitemimage(item.id,item.showonmenu)" color="primary " fab x-small dark class="mt-2 mb-2">
                                                                                    <v-icon>mdi-camera-plus-outline</v-icon>
                                                                                </v-btn>
                                                                            </v-list-item>
                                                                            <v-list-item>
                                                                                <v-btn icon @click="edititem(item.id)" color="primary " fab x-small dark class="mt-2 mb-2">
                                                                                    <v-icon>mdi-square-edit-outline</v-icon>
                                                                                </v-btn>
                                                                            </v-list-item>
                                                                            <v-list-item>
                                                                                <v-btn justify="center" icon @click="deleteItemCourse(item.id)" color="primary " fab x-small dark class="">
                                                                                    <v-icon>mdi-trash-can-outline</v-icon>
                                                                                </v-btn>
                                                                            </v-list-item>
                                                                        </v-list>
                                                                    </v-menu>
                                                            </v-col>
                                                            <v-col class="pa-0">
                                                                    <div class="d-flex justify-end" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                                    <v-switch style="font-size:12px !important;" color="success" :input-value="shw"  @click.stop="updateshowitem(drink.id,0)" :id="'showonitem-'+item.id"></v-switch>
                                                                    </div>
                                                                    <div class="d-flex justify-end" v-else>
                                                                        <v-switch style="font-size:12px !important;" color="" :input-value="nshw"  @click.stop="updateshowitem(drink.id,0)" :id="'showonitem-'+item.id"></v-switch>
                                                                    </div>
                                                            </v-col>
                                                        </v-row>

                                                <!-- <v-icon v-if="$store.getters.user" size="16" @click.prevent="drinkitemimage(item.id,item.showonmenu)" color="#fe5800" style="top:5px;right:10px;position:absolute;">mdi mdi-file-image-outline</v-icon> -->

                                                <v-card-text
                                                class="pt-0 pb-0"
                                                >

                                                <v-col cols="12" class="pa-0 ma-0">

                                                            <v-row class="pt-2 ml-0 mr-0">
                                                                <v-col cols="9" class="pa-0">
                                                                    <v-row cols="12" class="ml-0 mr-0" v-if="drink.name!='NULL' || drink.name!=NULL">
                                                                        <!-- <v-row class="ml-0"> -->
                                                                        <v-col cols="12" md="12" class="pa-0">
<!-- Drink Title -->
                                                                            <h3 class="drink-title">{{drink.name}}</h3>
                                                                        </v-col>
                                                                    </v-row>
<!-- Drink Sub-Title -->
                                                                    <v-row cols="12" class="ml-0 mr-0" v-if="drink.subtitle!='NULL' || drink.subtitle!=NULL">
                                                                        <v-col cols="12" md="12" class="pa-0 drink-subtitle-list">
                                                                            {{drink.subtitle}}
                                                                        </v-col>
                                                                    </v-row>
<!-- Drink Strapline  -->
                                                                    <v-row cols="12" class="ml-0 mr-0" v-if="drink.brand!='NULL' || drink.brand!=NULL">
                                                                        <v-col cols="12" md="12" class="pa-0 drink-strapline-list">
                                                                            {{drink.brand}}
                                                                        </v-col>
                                                                    </v-row>

                                                                </v-col>

                                                                <!-- <v-col cols="3" class="mr-0 pt-0 pb-0 text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                                    <v-icon class="pulse" size="16" color="#fe5800" @click.stop="edititem(drink.id)">fa fa-cog fa-spin</v-icon>
                                                                </v-col> -->
                                                            </v-row>
<!-- Drink Description (short-description) -->
                                                            <v-col cols="12" md="12" sm="12" class="drink-description-list-view ma-0 pa-0">
                                                                <p class="drink-description-list-view"  v-html="drink.shortdes"></p>
                                                            </v-col>

<!-- Drink Price Section -->
                                                            <v-row v-if="drink.measures.length>0 && !drink.separation" style="line-height: 12px !important" class="ml-0 mr-0 mb-2">
                                                                <v-col cols="12" v-for="(measure, index) in drink.measures" :key="'p'+index" class="pt-0 pb-0">

                                                                    <!-- <div><span style="font-weight:bold;">Name :</span>{{measure.mname}} <span style="font-weight:bold;">Price :</span>{{measure.price}}<span style="font-weight:bold;"> Unit :</span><span>{{measure.qty}}</span> {{measure.unit}}</div> -->
                                                                    <!-- <div>{{measure.mname}} <span class="pl-1 pr-1">{{measure.price}}</span><span class="pl-1 pr-1">{{measure.qty}}{{measure.unit}}</span> </div> -->

                                                                    <v-row >
                                                                        <v-col cols="4" md="4" class="drink-price-measure-list mr-0">
                                                                            {{measure.mname}}
                                                                        </v-col>
                                                                        <v-col cols="4" md="4" class="drink-price-unit-list mr-0">
                                                                            {{measure.qty}}{{measure.unit}}
                                                                        </v-col>
                                                                        <v-col cols="2" md="2" class="drink-price-list mr-0">
                                                                            <!-- <i class="fa " :class="business.currency.icon" aria-hidden="true"></i> -->
                                                                            {{measure.price}}
                                                                            <!-- Drink Price Heart or Shopping Cart Icon                                                                                  -->
                                                                        </v-col>
                                                                        <v-col cols="2" md="2" class="drink-price-icon-list">


                                                                            <v-row class="ma-0">
                                                                                <v-col cols="12" class="drink-favorite" v-if="checkitemfavoritedrink(drink.id,drink.typeid,measure.mname)">
                                                                                    <v-icon v-if="showcard==1"  size="16" color="#fe5800" @click.stop="togglefav(drink.id,drink.name,drink.subtitle,drink.image,drink.typeid,drink.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart</v-icon>
                                                                                    <v-icon v-else-if="showcard==0"  size="16" color="#fe5800" @click.stop="togglefav(drink.id,drink.name,drink.subtitle,drink.image,drink.typeid,drink.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart</v-icon>
                                                                                    <!-- <span class="mr-2">{{measure.mname}}</span>-->
                                                                                </v-col>
                                                                                <v-col cols="12" class="drink-favorite"  v-else>
                                                                                    <v-icon v-if="showcard==1"  size="10" color="#949494" @click.stop="togglefav(drink.id,drink.name,drink.subtitle,drink.image,drink.typeid,drink.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart-outline</v-icon>
                                                                                    <v-icon v-if="showcard==0"  size="10" color="#949494" @click.stop="togglefav(drink.id,drink.name,drink.subtitle,drink.image,drink.typeid,drink.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart-outline</v-icon>
                                                                                    <!-- <span class="mr-2">{{measure.mname}}</span> -->
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                    </v-col>
                                                </v-card-text>
                                            </v-card>


                                        </div>

                                    </v-row>

<!-- ############# DRINK LIST VIEW STARTS HERE ################ -->

                                    <v-row v-if="foodview=='list'" >
                                        <v-col cols="12" v-for="(drink,ind) in item" :key="ind"
                                        class="pb-0 pt-0 mb-2" v-show="!drink.hasallergen">

                                            <a @click.stop="drinkitemdetails(drink.id,'','drink',drink.separation)" >

                                                <!-- <v-card style="position: relative"> -->
                                                <v-card :style="{'border-color': business.themecolor}"
                                                        elevation="24" class="max-400 ma-0 pa-0 mb-1 cardborder-listView" :class="[drink.hasimage?'':'noimagecard',drink.separation? 'section-heading primary':'', drink.separation=='Feature'? 'strokedcard':'' ]" tile>
<!-- START OF COG POP UP MENU   LIST VIEW                                             -->
                                                    <div>
                                                        <v-row style="top:-4px; right:0px; position:absolute; z-index=7" class="pl-2 pr-3" justify="space-between" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                            <v-menu class="" @click.native.stop  transition="fab-transition">
                                                                <template v-slot:activator="{ on, attrs }"
                                                                top
                                                                left
                                                                transition="scale-transition"
                                                                >
                                                                    <v-btn @click.stop color="#FE5800" icon v-bind="attrs" v-on="on">
                                                                        <v-icon  class="compact-cogs-75" :class="[drink.separation? 'invert-text-colour ':'']">fa fa-cogs</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-icon color="red" icon dark class="close-menu-left pa-0 ma-0pt-2 pl-2" :class="[drink.separation? 'invert-text-colour ':'']">
                                                                    mdi-close-circle
                                                                </v-icon>
                                                                <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1" :class="[drink.separation?'primary ':'']">
                                                                    <v-list-item v-if="drink.separation==1" class="text-left" >
                                                                        <span style="color:#FE5800" class="mt-4 course-text-heading"><p :class="[drink.separation?'invert-text-colour ':'']">{{$t('zz_section')}}</p></span>
                                                                    </v-list-item>
                                                                    <v-list-item>
                                                                        <span v-if="drink.separation==0" style="color:#FE5800" class="mt-6 course-text-heading" :class="[drink.separation? 'invert-text-colour ':'']">
                                                                            {{drink.name}}
                                                                        </span>
                                                                    </v-list-item>
                                                                    <div class="mt-0 pl-0 pr-0 d-flex" v-if="drink.showonmenu==1">
                                                                        <v-switch no-gutters style="font-size:12px !important;" color="success" :input-value="shw"  @click.stop="updateshowitem(drink.id,0)" :id="'showonitem-'+item.id">
                                                                        </v-switch>
                                                                    </div>
                                                                    <div class="d-flex" v-else>
                                                                        <v-switch no-gutters style="font-size:12px !important;" color="" :input-value="nshw"  @click.stop="updateshowitem(drink.id,1)" :id="'showonitem-'+item.id">
                                                                        </v-switch>
                                                                    </div>
                                                                    <v-list-item>
                                                                        <v-btn icon @click="edititem(drink.id)" color="#FE5800 " fab x-small dark class="mt-2 mb-2" :class="[drink.separation? 'invert-text-colour ':'']">
                                                                            <v-icon>mdi-square-edit-outline</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                    <div v-if="drink.separation==0">
                                                                        <!-- <v-list-item>
                                                                            <v-btn icon @click.prevent="foodstatusupdate(food.id,'From Chef')" color="#FE5800 " fab x-small dark class="mt-2 mb-2" :class="[drink.separation? 'invert-text-colour ':'']">
                                                                                <v-icon>mdi-chef-hat</v-icon>
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                        <v-list-item>
                                                                            <v-btn icon @click.prevent="foodstatusupdate(food.id,'Feature')" color="#FE5800 " fab x-small dark class="mt-2 mb-2" :class="[drink.separation? 'invert-text-colour ':'']">
                                                                                <v-icon>mdi-star-shooting-outline</v-icon>
                                                                            </v-btn>
                                                                        </v-list-item> -->
                                                                        <v-list-item>
                                                                            <v-btn icon @click.prevent="drinkitemimage(drink.id,drink.showonmenu)" color="#FE5800" fab x-small dark class="mt-2 mb-2" :class="[drink.separation? 'invert-text-colour ':'']">
                                                                                <v-icon>mdi-camera-plus-outline</v-icon>
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                        <v-list-item>
                                                                            <v-btn justify="center" icon @click="deleteItem(drink.id)" color="#FE5800 " fab x-small dark class="" :class="[drink.separation? 'invert-text-colour ':'']">
                                                                                <v-icon>mdi-trash-can-outline</v-icon>
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                    </div>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-row>
                                                    </div>
<!-- END OF COG POP UP MENU                                                      -->
                                                    <v-col cols="12" md="12" class="ma-0 pa-0 separator-drink-card">
                                                        <v-row no-gutters dense style="align-items: flex-end" class="">
                                                            <v-col v-if="drink.separation==0" cols="4" md="4" class="ma-0 pa-0">
                                                                <div no-gutters dense v-if="drink.fimage!=''" class="text-center ma-0 pa-0">
                                                                    <v-img class=" ma-0 pa-0 my-1"

                                                                         contain
                                                                         max-height="100px"
                                                                         width="100%"

                                                                         :src="drink.fimage">

                                                                    </v-img>
                                                                </div>
                                                            </v-col>
                                                            <v-col v-if="drink.separation==0" cols="8" md="8" class="drink-card-text-area">
                                                                <v-row class="pt-2 ml-0 mr-0">
                                                                    <v-col cols="9" class="pa-0">
                                                                        <v-row cols="12" class="ml-0 mr-0" v-if="drink.name!='NULL' || drink.name!=NULL">

                                                                            <v-col cols="12" md="12" class="pa-0">
<!-- Drink Title -->
                                                                                <p class="" :class="[drink.separation? 'separator-title':'drink-title' ]">
                                                                                    <!-- {{drink.name}} -->
                                                                                         {{userlangcode==''?drink.name:drink.langtransaltions[userlangcode].title}}

                                                                                    </p>
                                                                            </v-col>
                                                                        </v-row>
<!-- Drink Sub-Title -->
                                                                        <v-row cols="12" class="ml-0 mr-0" v-if="drink.subtitle!='NULL' || drink.subtitle!=NULL">
                                                                            <v-col cols="12" md="12" class="pa-0 drink-subtitle-list" :class="[drink.separation? 'separator-subtitle':'' ]">
                                                                                <!-- {{drink.subtitle}} -->
                                                                                {{userlangcode==''?drink.subtitle:drink.langtransaltions[userlangcode].subtitle}}

                                                                            </v-col>
                                                                        </v-row>
<!-- Drink Strapline  -->
                                                                        <v-row cols="12" class="ml-0 mr-0" v-if="drink.brand!='NULL' || drink.brand!=NULL">
                                                                            <v-col v-if="drink.separation==0" cols="12" md="12" class="pa-0 drink-strapline-list">
                                                                                {{drink.brand}}
                                                                            </v-col>
                                                                        </v-row>

                                                                    </v-col>
                                                                </v-row>

                                                                    <!-- <v-col cols="3" class="mr-0 pt-0 pb-0 text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                                       <v-icon class="pulse" size="16" color="#fe5800" @click.stop="edititem(drink.id)">fa fa-cog fa-spin</v-icon>
                                                                    </v-col> -->
                                                            <!-- </v-col> -->
<!-- Drink Description (short-description) -->

<!-- drink.separation -->
                                                                <div v-if="drink.separation==0">
                                                                    <v-col v-if="drink.separation==0" cols="12" md="12" sm="12" class="pa-0 ma-0 mt-1 mb-1 drink-description-list-view">
                                                                        <p class="drink-description-list-view"  v-html="userlangcode==''?drink.shortdes:drink.langtransaltions[userlangcode].description"></p>
                                                                    </v-col>
                                                                    <!-- </v-col> -->
        <!-- Drink Price Section -->
                                                                    <v-col cols="12" md="12" sm="12" class="ma-0 pa-0">
                                                                        <v-row v-if="drink.measures.length>0 && !drink.separation" style="line-height: 12px !important" class="ml-0 mr-0 mb-2 drink-price-section">
                                                                            <v-col cols="12" v-for="(measure, index) in drink.measures" :key="'p'+index" class="pt-0 pb-0">
                                                                                <!-- <div><span style="font-weight:bold;">Name :</span>{{measure.mname}} <span style="font-weight:bold;">Price :</span>{{measure.price}}<span style="font-weight:bold;"> Unit :</span><span>{{measure.qty}}</span> {{measure.unit}}</div> -->
                                                                                <!-- <div>{{measure.mname}} <span class="pl-1 pr-1">{{measure.price}}</span><span class="pl-1 pr-1">{{measure.qty}}{{measure.unit}}</span> </div> -->
                                                                                <v-row style="align-items: baseline">
                                                                                    <v-col cols="7" md="7" class="drink-price-measure-list mr-0">
                                                                                        {{measure.mname}}<span class="drink-price-unit-list mr-0 text-right"> {{measure.qty}}{{measure.unit}}</span>
                                                                                    </v-col>
                                                                                    <!-- <v-col cols="2" md="2" class="drink-price-unit-list mr-0 text-left">
                                                                                        {{measure.qty}}{{measure.unit}}
                                                                                    </v-col> -->
                                                                                    <v-col cols="3" md="3" class="drink-price-list mr-0">
                                                                                        <!-- <i class="fa " :class="business.currency.icon" aria-hidden="true"></i> -->
                                                                                        {{measure.price}}
                                                                                        <!-- Drink Price Heart or Shopping Cart Icon                                                                                  -->
                                                                                    </v-col>
                                                                                    <v-col cols="2" md="2" class="drink-price-icon-list">


                                                                                        <v-row class="ma-0">
                                                                                            <v-col cols="12" class="drink-favorite" v-if="checkitemfavoritedrink(drink.id,drink.typeid,measure.mname)">
                                                                                                <v-icon v-if="showcard==1"  size="16" color="#fe5800" @click.stop="togglefav(drink.id,drink.name,drink.subtitle,drink.image,drink.typeid,drink.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart</v-icon>
                                                                                                <v-icon v-else-if="showcard==0"  size="16" color="#fe5800" @click.stop="togglefav(drink.id,drink.name,drink.subtitle,drink.image,drink.typeid,drink.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart</v-icon>
                                                                                                <!-- <span class="mr-2">{{measure.mname}}</span>-->
                                                                                            </v-col>
                                                                                            <v-col cols="12" class="drink-favorite"  v-else>
                                                                                                <v-icon v-if="showcard==1"  size="10" color="#949494" @click.stop="togglefav(drink.id,drink.name,drink.subtitle,drink.image,drink.typeid,drink.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart-outline</v-icon>
                                                                                                <v-icon v-if="showcard==0"  size="10" color="#949494" @click.stop="togglefav(drink.id,drink.name,drink.subtitle,drink.image,drink.typeid,drink.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart-outline</v-icon>
                                                                                                <!-- <span class="mr-2">{{measure.mname}}</span> -->
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </div>
                                                            </v-col>
                                                            <v-col v-if="drink.separation==1" cols="12" md="12" class="separator-drink-card-text-area">
                                                                <v-row class="separator-drink-title-list">
                                                                        {{drink.name}}
                                                                </v-row>
                                                                <v-row class="separator-drink-subtitle-list">
                                                                        {{drink.subtitle}}
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-card>
                                            </a>
                                        </v-col>
                                    </v-row>
                        </v-tab-item>

                    </v-tabs>


<!-- Edit Drink Item Photo  -->


                    <v-dialog v-model="itemimagedialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card tile class="bbredD" elevation="3">
                            <v-card-text class="pa-0 carddetail" elevation="3" color="#fff">
                                <v-form class="" v-model="valid" enctype="multipart/form-data" id="editfooditem">
                                    <v-row>
                                        <v-col cols="12" md="12" class="text-center mt-10"><h4>{{$t('zz_update')}}</h4></v-col>
                                    </v-row>
                                    <v-row clos="10" md="10" class="mx-2 px-5" style="justify-content: center">
                                        <p>ONLY USE IMAGES THAT YOU HAVE PERMISSION TO USE</p>
                                    </v-row>
                                    <div style="bottom:10%; position:absolute">
                                        <v-row>
                                            <v-col cols="12" md="12" sm="12">
                                            <v-row v-if="mainimguploading">
                                                <v-col cols="12" class="text-center">
                                                    <v-progress-circular
                                                    indeterminate
                                                    color="primary"
                                                    ></v-progress-circular>
                                                </v-col>
                                            </v-row>
                                            <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange" />
                                            <v-row>
                                                <v-col cols="12" md="12" sm="12" class="text-center mb-5 mt-3" >
                                                <!-- <v-img class="backimg"  :src="addphoto" @click="$refs.file.click()" style="max-height:200px;background-size: contain;"> -->
                                                    <input
                                                    type="file"
                                                    ref="file"
                                                    @change="uploadImage($event)"
                                                    accept="image/*"
                                                    class=""
                                                    id="itemimage"
                                                    />
                                                <!-- </v-img> -->
                                                </v-col>
                                                <v-col cols="12" md="12" sm="12" class="text-center mb-9">
                                                    <v-row align="center" justify="space-around">
                                                        <v-btn
                                                            depressed
                                                            color="#fe5800"
                                                            @click.stop="updateimage">
                                                            {{$t('zz_update')}}
                                                        </v-btn>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-form>
                            </v-card-text>

                        </v-card>

                        <v-footer
                        absolute
                        class="font-weight-medium "
                        color="transparent">
                            <v-col
                                class="text-center"
                                cols="12">
                                <v-btn @click="backtomenuimage" fab small color="#fe5800" >
                                    <v-icon class="white--text ">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-footer>
                    </v-dialog>

<!-- ############## Drink Detail Card Popup #################-->


                    <v-dialog class="drink-detail-card" v-model="itemdialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
                             <v-card tile class="" elevation="3" v-show="drinkitemid>0" >

                            <!-- <v-col cols="12" class="mr-auto text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                <v-icon style="top: 10%; right:0px; position:fixed; z-index=11" class="white-compact-cogs-75 cogtab " size="26" @click.stop="edititem(drinkitem.id)">fa fa-cogs</v-icon>
                            </v-col> -->

                        <v-card-text class="pa-0">
<!-- REMOVE FOR LIVE COPY  -->

                                <v-container  class="pa-0 ma-0 mt-10">
                                    <v-row style="align-items:center;" col="12" class="pa-0 ma-0">
                                    <v-col cols="5" class="pa-0 ma-0">
                                            <v-img contain :src="drinkitem.fimage" aspect-ratio="1" class="text-right drink-detail-card-drink-image">
                                            </v-img>
                                    </v-col>
                                    <v-col cols="7">
                                            <v-row class="">
                                                <v-col cols="12" md="12" sm="12" class="">
                                                    <div style="position:static" class="drink-detail-card-title">
                                                        <span cols="12" class="mr-auto text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                            <v-icon style="top: 10%; right:0px; position:fixed; z-index=11" class="white-compact-cogs-75 cogtab " size="26" @click.stop="edititem(drinkitem.id)">fa fa-cogs</v-icon>
                                                        </span>
                                                    </div>
                                                    <div class="drink-detail-card-title">
                                                        <span >{{itemdialog?(userlangcode=='' ?drinkitem.name:drinkitem.langtransaltions[userlangcode].title):drinkitem.name}}</span>
                                                    </div>
                                                    <div class="drink-detail-card-subtitle" style="line-height:1">
                                                        <span >{{itemdialog?(userlangcode=='' ?drinkitem.subtitle:drinkitem.langtransaltions[userlangcode].subtitle):drinkitem.subtitle}}</span>
                                                    </div>
                                                    <v-divider class="pb-4 pt-0 ml-0 mr-0"></v-divider>
                                                    <v-col cols="12" v-for="(measure, index) in drinkitem.measures" :key="'p'+index" class="pt-0 pb-0 pl-0 pr-0 ma-0">
                                                        <v-row class="ma-0">
                                                            <v-col cols="4" md="4" class="paired-drink-detail-card-measure">
                                                                {{measure.mname}}
                                                            </v-col>
                                                            <v-col cols="3" md="3" class="paired-drink-detail-card-unit">
                                                                {{measure.qty}}{{measure.unit}}
                                                            </v-col>
                                                            <v-col cols="3" md="3" class="paired-drink-detail-card-price">
                                                                {{measure.price}}
                                                            </v-col>
                                                            <v-col cols="2" md="2" class="paired-drink-detail-card-price">
                                                                <v-row>
                                                                    <v-col cols="12" class="align-end drink-favorite pb-0 pt-0" v-if="checkitemfavoritedrink(drinkitem.id,drinkitem.typeid,measure.mname)">
                                                                        <v-icon v-if="showcard==1"  size="16" color="#fe5800" @click.stop="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart</v-icon>
                                                                        <v-icon v-else-if="showcard==0"  size="16" color="#fe5800" @click.stop="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart</v-icon>
                                                                    </v-col>
                                                                    <v-col cols="12" class="drink-favorite pb-0 pt-0"  v-else>
                                                                        <v-icon v-if="showcard==1"  size="10" color="#949494" @click.stop="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart-outline</v-icon>
                                                                        <v-icon v-if="showcard==0"  size="10" color="#949494" @click.stop="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart-outline</v-icon>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-col>
                                            </v-row>
                                    </v-col>
                                    </v-row>
                                </v-container>
                                <v-row class="ma-0 pt-10">


                                    <v-col cols="12" md="12" sm="12" class="pl-8 pr-8 pt-5">
                                        <div class="drink-detail-card-description">

                                            <!-- ==============================
                                            <div> {{drinkitem.description}}
                                            </div>
                                            ============================== -->

                                            <div v-html="itemdialog?(userlangcode=='' ?drinkitem.description:drinkitem.langtransaltions[userlangcode].description):drinkitem.description"></div>
                                            <!-- <div v-html="drinkitem.description">
                                            </div> -->
                                        </div>
                                    </v-col>
                            </v-row>

<!-- Drink categori detials  -->
                                <!-- <v-row v-if="drinkitem.categories.length>0" class="ma-0">
                                    <v-col cols="12" class="pb-0 pl-0 pr-0">
                                        <p class="drink-detail-card-section-headings">{{$t('zz_categories')}}</p>
                                    </v-col>
                                    <v-col cols="4" v-for="(category, index) in drinkitem.categories" :key="'p'+index" class="text-center pl-3 pr-3">
                                        <div>{{category.name}} </div>
                                    </v-col>
                                </v-row> -->

<!-- Drink Allergens  -->

                                <v-row class="ma-0" v-if="drinkitem.allergens.length>=1">
                                    <v-col cols="12" md="12">
                                    <!-- <div style="color:#FE5800;line-height: 0.5;">{{$t('zz_this_dish_contians_the_following_items')}}</div> -->
                                    <v-divider class="pb-4 ml-0 mr-0"></v-divider>
                                    <p class="detail-card-food-allergen-warning pl-8 pr-8">
                                        {{$t('zz_this_dish_contians_the_following_items')}}</p>
                                    </v-col>
                                </v-row>

                                <v-row v-if="drinkitem.allergens.length>0" class="ma-0">
                                    <v-col cols="12" class="pb-15 pl-0 pr-0">
                                    <p class="drink-detail-card-section-headings">{{$t('zz_allergens')}}</p>
                                    </v-col>

                                    <v-col cols="3" v-for="(allergen, index) in drinkitem.allergens" :key="'p'+index" class="display-allergens pl-3 pr-3">
                                        <img :src="allergen.image"  width="20"/>
                                        <br>
                                        <span v-html="allergen.name"></span>
                                        <!-- {{allergen.name}} -->
                                    </v-col>
                                </v-row>
                                <div class="pb-8"></div>

                                <v-divider></v-divider>


                                    <p class="powered-by-juzzap">powered by juZZap</p>
                            </v-card-text>
                        </v-card>



                        <!-- <v-card tile class="" elevation="3" v-show="drinkitemid>0" >
                        <v-card-text class="pa-0">
                                <v-row class="ma-0 pt-10">
                                    <v-col cols="5" class="pa-0 ma-0">
                                            <v-img contain :src="drinkitem.fimage" aspect-ratio="1" class="text-right drink-detail-card-drink-image">
                                            </v-img>
                                    </v-col>
                                    <v-col cols="7">
                                        <v-col>
                                            <v-row>
                                                <v-col cols="12" md="12" sm="12" class="">
                                                    <div style="position:static" class="drink-detail-card-title">
                                                        <span cols="12" class="mr-auto text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                            <v-icon style="top: 10%; right:0px; position:fixed; z-index=11" class="white-compact-cogs-75 cogtab " size="26" @click.stop="edititem(drinkitem.id)">fa fa-cogs</v-icon>
                                                        </span>
                                                    </div>
                                                    <div class="drink-detail-card-title">
                                                        <span >{{itemdialog?(userlangcode=='' ?drinkitem.name:drinkitem.langtransaltions[userlangcode].title):drinkitem.name}}</span>
                                                    </div>
                                                    <div class="drink-detail-card-subtitle" style="line-height:1">
                                                        <span >{{itemdialog?(userlangcode=='' ?drinkitem.subtitle:drinkitem.langtransaltions[userlangcode].subtitle):drinkitem.subtitle}}</span>
                                                    </div>
                                                    <v-divider class="pb-4 pt-0 ml-0 mr-0"></v-divider>
                                                    <v-col cols="12" v-for="(measure, index) in drinkitem.measures" :key="'p'+index" class="pt-0 pb-0 pl-0 pr-0 ma-0">
                                                        <v-row class="ma-0">
                                                            <v-col cols="4" md="4" class="paired-drink-detail-card-measure">
                                                                {{measure.mname}}
                                                            </v-col>
                                                            <v-col cols="3" md="3" class="paired-drink-detail-card-unit">
                                                                {{measure.qty}}{{measure.unit}}
                                                            </v-col>
                                                            <v-col cols="3" md="3" class="paired-drink-detail-card-price">
                                                                {{measure.price}}
                                                            </v-col>
                                                            <v-col cols="2" md="2" class="paired-drink-detail-card-price">
                                                                <v-row>
                                                                    <v-col cols="12" class="align-end drink-favorite pb-0 pt-0" v-if="checkitemfavoritedrink(drinkitem.id,drinkitem.typeid,measure.mname)">
                                                                        <v-icon v-if="showcard==1"  size="16" color="#fe5800" @click.stop="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart</v-icon>
                                                                        <v-icon v-else-if="showcard==0"  size="16" color="#fe5800" @click.stop="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart</v-icon>
                                                                    </v-col>
                                                                    <v-col cols="12" class="drink-favorite pb-0 pt-0"  v-else>
                                                                        <v-icon v-if="showcard==1"  size="10" color="#949494" @click.stop="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart-outline</v-icon>
                                                                        <v-icon v-if="showcard==0"  size="10" color="#949494" @click.stop="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart-outline</v-icon>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12" class="pl-8 pr-8 pt-5">
                                        <div class="drink-detail-card-description">
                                            <div v-html="itemdialog?(userlangcode=='' ?drinkitem.description:drinkitem.langtransaltions[userlangcode].description):drinkitem.description"></div>
                                        </div>
                                    </v-col>
                            </v-row>
                                <v-row class="ma-0" v-if="drinkitem.allergens.length>=1">
                                    <v-col cols="12" md="12">
                                    <v-divider class="pb-4 ml-0 mr-0"></v-divider>
                                    <p class="detail-card-food-allergen-warning pl-8 pr-8">
                                        {{$t('zz_this_dish_contians_the_following_items')}}</p>
                                    </v-col>
                                </v-row>
                                <v-row v-if="drinkitem.allergens.length>0" class="ma-0">
                                    <v-col cols="12" class="pb-15 pl-0 pr-0">
                                    <p class="drink-detail-card-section-headings">{{$t('zz_allergens')}}</p>
                                    </v-col>
                                    <v-col cols="3" v-for="(allergen, index) in drinkitem.allergens" :key="'p'+index" class="display-allergens pl-3 pr-3">
                                        <img :src="allergen.image"  width="20"/>
                                        <br>
                                        <span v-html="allergen.name"></span>
                                    </v-col>
                                </v-row>
                                <div class="pb-8"></div>
                                <v-divider></v-divider>
                                    <p class="powered-by-juzzap">powered by juZZap</p>
                            </v-card-text>
                        </v-card> -->
<!-- Drink detial Card Close Icon  -->
                        <v-footer
                            fixed
                            class="font-weight-medium "
                            color="transparent">
                                <v-col
                                    class="text-center"
                                    cols="12"
                                >
                                    <v-btn @click="itembacktomenu" fab small color="#fe5800" >
                                        <v-icon class="white--text ">mdi-close</v-icon>
                                    </v-btn>
                                </v-col>
                        </v-footer>


                    </v-dialog>


        <!-- Order Detial Card order details popup -->

        <v-dialog v-model="orderdialog" content-class="orderdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
           <v-card v-if="orderdialog==true" tile class="" elevation="3" color="#fff">
                <ordercomponent   :orderdetail="order" :ordercourses="ordercourses" :business="business" v-on:set-dialog="backtofood" v-on:deleteitem="deleteorderitem" v-on:setordercoursesitem="updateorder" v-on:saveorderitem="saveorder"/>
            </v-card>
        </v-dialog>

                    <v-dialog v-model="fooditemdialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">

                        <v-card tile class="carddetail" elevation="3" color="#fff"   v-show="fooditemid>0" >






                            <v-card-text class=" pa-0 carddetail ">
                                <v-img height="241" :src="fooditem.fimage" aspect-ratio="1" class="carddetail">

                                    <div class="white--text carddetail" :style="[ fooditem.foodstatus=='From Chef'?{'background-color': business.themecolor}:{'background-color': '#FE5800'} ]" style="position:absolute;bottom:0px;left:0px;text-align:center;width:190px;height:41px;line-height:41px" v-if="fooditem.foodstatus=='From Chef'"><v-icon color="#fff">mdi-chef-hat</v-icon> Chef's Choice</div>
                                </v-img>


                                <v-row>
                                    <v-col cols="4" md="4" sm="4">
                                        <v-row>
                                            <v-col cols="6" v-for="(allergen, index) in fooditem.allergens" :key="'p'+index" class="text-center pl-3 pr-3">
                                                <img :src="allergen.image"  width="32"/>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="4" md="4" sm="4">
                                        <v-row>
                                            <v-col cols="6" v-for="(meat, index) in fooditem.meats" :key="'m'+index" class="text-center">
                                                <img :src="meat.image"  width="32"/>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="4" md="4" sm="4">
                                        <v-row>
                                        <v-col cols="12" class="pl-1 pr-1"><span v-for="n in 5" :key="n" class="chili-size">
                                            <img :src="n<=fooditem.chillispice?chilli:chillio" width="20">
                                            <!-- <v-icon :color="n<=fooditem.chillispice?'red':''" >mdi-chili-mild</v-icon> -->
                                        </span></v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row class="ma-0">

                                    <v-col cols="9" md="9" sm="9" class=" pl-3 pr-3">


                                        <div class="headline font-weight-bold" style="text-transform:uppercase;">{{fooditem.title}}</div>
                                        <div class="subtitle-1 font-weight-light" style="line-height:1">{{fooditem.subtitle}}</div>
                                        <div class="primary--text" v-if="fooditem.id!=0 "
                                            :style="[ business.themecolor!=''?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                            style="line-height:1;font-size:14px;font-weight:bold;" >
                                            {{fooditem.courses[0].coursename}}

                                        </div>

                                    </v-col>

                                    <v-col cols="3" class="pl-1 pb-0" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                        <v-icon class="pulse" size="16" color="#fe5800" @click.stop="edititem(fooditem.id)">fa fa-cog fa-spin</v-icon>
                                    </v-col>

                                    <!-- <a @click="togglefav(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image)">
                                            <img :src="imgfavminus" width="46" />

                                        </a> -->

                                    <v-col cols="3" class="text-right pl-3 pr-3" v-else-if="fooditem.id!=0 && checkitemfavorite(fooditem.id,fooditem.courses[0].cid)">
                                        <a @click="togglefavfood(fooditem.id,fooditem.courses[0].cid,fooditem.courses[0].coursename,fooditem.courses[0].price,fooditem.fimage,fooditem.title,fooditem.subtitle)">
                                            <img :src="imgfavminus" width="46" />
                                        </a>
                                    </v-col>
                                    <v-col cols="3" class="text-right pl-3 pr-3" v-else>
                                        <a @click="togglefavfood(fooditem.id,fooditem.courses[0].cid,fooditem.courses[0].coursename,fooditem.courses[0].price,fooditem.fimage,fooditem.title,fooditem.subtitle)">
                                            <img :src="imgfavplus" width="46" />
                                        </a>
                                    </v-col>


                                </v-row>
                                <v-row class="ma-0">
                                    <!-- <v-col cols="12" class="pb-0">
                                    <h2 class="title">Description</h2>
                                    </v-col> -->
                                    <v-col cols="12" class="pt-0 pl-3 pr-3" v-html="fooditem.description"></v-col>
                                </v-row>



                                <v-row v-if="fooditem.drinkitems.length" class="ma-0">
                                    <v-col cols="12" class="pb-0 pl-3 pr-3">
                                        <h2 class="title">Drink Pairing</h2>
                                    </v-col>
                                    <v-col cols="6" v-for="(drinkitem, index) in fooditem.drinkitems" :key="'d'+index" class="text-center">

                                        <v-card
                                        tile
                                        class="mx-auto cardborder "
                                        max-width="100%"
                                        @click.prevent="drinkitemdetails(drinkitem.drinkid,drinkitem.typeid,drinkitem.separation)"
                                        >

                                            <v-img
                                            :src="drinkitem.image"
                                            class="drinkimg"
                                            height="250px"
                                            max-width="50%"
                                            style="position:relative"
                                            >

                                            </v-img>

                                            <v-card-text>
                                                <v-row>
                                                    <v-col cols="10" md="10" class="drink-title pa-0 pb-3">
                                                        {{drinkitem.name}}

                                                    </v-col>
                                                    <v-col cols="2" class="pl-1 pt-0 pb-0 favorite" v-if="checkitemfavorite(drinkitem.drinkid,drinkitem.typeid)">



                                                        <v-icon  @click.stop="togglefavdrink(drinkitem.drinkid,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,'drink')" size="16" color="#fe5800">mdi-cart-outline</v-icon>

                                                    </v-col>
                                                    <v-col class="pl-1 pb-0 pt-0" cols="2" v-else>



                                                            <v-icon  @click.stop="togglefavdrink(drinkitem.drinkid,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,'drink')" size="16" color="#fe5800">mdi-cart</v-icon>

                                                    </v-col>
                                                    <v-col cols="12" v-for="(measure, index) in drinkitem.measures" :key="'m'+index" class="text-center pb-0 pt-0">
                                                        <v-row>
                                                            <v-col cols="4" md="4" class="pa-0">
                                                                {{measure.mname}}
                                                            </v-col>
                                                            <v-col cols="4" md="4" class="pa-0">
                                                                <i class="fa " :class="business.currency.icon" aria-hidden="true"></i>{{measure.price}}
                                                            </v-col>
                                                            <v-col cols="4" md="4" class="pa-0">
                                                                {{measure.qty}}{{measure.unit}}
                                                            </v-col>
                                                        </v-row>
                                                        <!-- <div>{{measure.mname}} <span class="pl-1 pr-1">{{measure.price}}</span><span class="pl-1 pr-1">{{measure.qty}}{{measure.unit}}</span> </div> -->

                                                    </v-col>

                                                </v-row>

                                            </v-card-text>

                                        </v-card>


                                    </v-col>
                                </v-row>

                                <v-divider></v-divider>
                                <v-row class="d-none">
                                    <v-col cols="12" class="pb-0">
                                        <h2 class="title">Add to your shortlist...</h2>
                                    </v-col>
                                    <v-col cols="12" >
                                        <v-row v-for="(course, index) in fooditem.courses" :key="'c'+index" align="center">
                                            <v-col cols="4">{{course.coursename}}</v-col>
                                            <v-col cols="5"><v-text-field @change="setitemtotal(course.courseid)" @keyup="setitemtotal(course.courseid)" @input="setitemtotal(course.courseid)" value="0" :name="'course['+course.courseid+']'" @click:append-outer="addqty(course.courseid)" :id="'course-'+course.courseid"
                                                @click:prepend="subtractqty(course.courseid)" min="0" type="number" :data-price="course.price" label="Qantity" prepend-icon="mdi-minus-circle-outline" append-outer-icon="mdi-plus-circle-outline" v-model="itemqty"></v-text-field></v-col>
                                            <v-col cols="3"><span class="mr-1" :id="'cp-'+course.courseid">{{parseFloat(course.price).toFixed(2)}}</span> </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" >
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="12" >
                                        <v-row>
                                            <v-col cols="6"><strong>Total</strong></v-col>

                                            <v-col cols="6" class="text-right"><strong class="mr-1" id="tp-total">0.00</strong> </v-col>

                                        </v-row>
                                    </v-col>
                                </v-row>
                                <p class="mb-12 pb-12"></p>

                            </v-card-text>



                            <!-- <v-footer
                            :color= "business.themecolor!=''?business.themecolor:'#FE5800'">
                                <v-row>
                                    <v-col cols="12" class="pa-0">
                                        <v-row>
                                            <v-col cols="4" class="pa-0">
                                                <v-btn text color="white" @click="backtomenu" ><v-icon>mdi-arrow-left</v-icon> Back</v-btn>
                                            </v-col>
                                            <v-col cols="8" class="text-right pa-0">
                                                <v-btn text color="white" @click="addtoorder" >
                                                    <img :src="favplus" width="25"/> Favourites
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-footer> -->
                        </v-card>

                        <v-footer
                        absolute
                        class="font-weight-medium "
                        color="transparent">
                                <v-col
                                    class="text-center"
                                    cols="12"
                                >
                                    <v-btn @click="backtodialog" fab small color="#fe5800" >
                                        <v-icon class="white--text ">mdi-close</v-icon>
                                    </v-btn>
                                </v-col>
                        </v-footer>


                    </v-dialog>

                </div>

<!--################ Allergen Filters Panel  Allergens Card ################   -->

                <div v-if="filter" style="padding-left:15px;padding-right:15px;">
                    <!-- <div style="padding-left:15px;padding-right:15px;"> -->
                    <!-- meat div -->
                    <v-container>
                        <v-row>
                            <v-col cols="12" style="color:#fe5800;">
                                {{$t('zz_diet')}}
                            </v-col>

                            <v-col cols="12" class="text-right">
                                <v-btn text tile
                                :color= "business.themecolor!=''?business.themecolor:'#FE5800'"
                                @click="setRemovedDiets">
                                    <span v-if="dietSelectAll">{{$t('zz_select_all')}}</span>
                                    <span v-else>{{$t('zz_clear_all')}}</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>

                            <v-col
                            :style="[ business.themecolor!=''?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                             style="font-size:12px;color:#FE5800;padding:2px;" cols="4" v-for="(diet, index) in business.diets" :key="'a'+index" class="text-center">

                            <v-btn block height="70" tile  @click="toggleDiet(diet.id)"

                            :outlined="removedDiets.indexOf(diet.id)==-1?false:true">
                                <div style="font-size:9px;">
                                    <span >
                                    <img style="display:block;margin:0 auto;padding:10px;" :src="diet.img"  width="45"/></span>


                                    <span class="text-wrap" v-html="diet.name"></span>

                                </div>
                            </v-btn>

                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" style="font-size:14px;text-align:center;">
                                Was this feature is useful for you ?

                            </v-col>
                            <v-col cols="12" class="text-center pa-0">
                                <v-rating
                                color= "#FE5800"

                                v-model="dietrating"></v-rating>
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="12" class="">
                                <!-- <v-btn color="primary" @click="filter=0">Close Filters</v-btn> -->
                                Please use the filters below to view only what you like, we will hide the rest!
                            </v-col>
                        </v-row>
                    </v-container>


                    <v-container>
                        <v-row>
                            <v-col cols="12" class="text-right">
                                <v-btn
                                :color= "business.themecolor!=''?business.themecolor:'#FE5800'"

                                @click="filter=0">{{$t('zz_close_filters')}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>



                <div v-if="filterAllergens" style="padding-left:15px;padding-right:15px;">

                    <v-row>

                        <!-- <v-col cols="12" style="font-weight:bold;color:black;"> -->
                        <v-col v-col cols="12" class="allergen-filter-title">
                                {{$t('zz_allergens')}}
                        </v-col>

                        <v-col v-col cols="12" class="allegen-filter-text">

                            <span v-html="$t('zz_allergens_text')"> </span>
                        </v-col>
                    </v-row>
                    <v-col cols="12" class="pb-5 ma-0">
                            <v-btn block
                            :color= "business.themecolor!=''?business.themecolor:'#FE5800'"
                            @click="saveAllergens()" outlined>{{$t('zz_save')}}</v-btn>
                        </v-col>
                    <v-row>
                        <v-col :style="[ business.themecolor!=''?{'color': business.themecolor}:{'color': '#00fe2c'} ]" style="font-size:12px; color:#00fe2c; padding:2px;" cols="4" v-for="(allergen, index) in business.allergen" :key="'a'+index" class="text-center">
                        <v-btn block height="90" tile  @click="addAllergens(allergen.id,allergen.name)"
                        :color= "business.themecolor!=''?business.themecolor:'#FE5800'"
                        :outlined="selectedAllergens.indexOf(allergen.id)!=-1?false:true">
                            <div style="font-size:9px;">
                                <span ><img style="display:block;margin:0 auto;padding:10px;" :src="allergen.image"  width="45"/></span>
                                <span class="text-wrap" v-html="allergen.name"></span>
                            </div>
                        </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" >
                            <v-btn block
                            :color= "business.themecolor!=''?business.themecolor:'#FE5800'"
                            @click="saveAllergens()" outlined>{{$t('zz_save')}}</v-btn>
                        </v-col>
                        <!-- <v-col cols="6" >
                            <v-btn color="primary" @click="noAllergens()" outlined>No Allergens</v-btn>
                        </v-col> -->
                    </v-row>
                    <v-row>
                        <v-col cols="12" style="font-size:14px;text-align:center;">
                            {{$t('zz_like_this_feature')}}

                        </v-col>
                        <v-col cols="12" class="text-center pa-0">
                            <v-rating
                            color= "#FE5800"
                            v-model="allergensrating"></v-rating>
                        </v-col>

                    </v-row>

                    <v-container>
                        <v-row>
                            <v-col cols="12" class="text-right">
                                <v-btn
                                :color= "business.themecolor!=''?business.themecolor:'#FE5800'"

                                @click="filterAllergens=0">{{$t('zz_close_filters')}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>

                <div v-if="filter">
                    <v-container>
                        <v-row>
                            <v-col cols="12" class="">
                                <!-- <v-btn color="primary" @click="filter=0">Close Filters</v-btn> -->
                                Please use the filters below to view only what you like, we will hide the rest!
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-container>
                        <v-row>
                            <v-col cols="12" class="text-right">
                                <v-btn
                                :color= "business.themecolor!=''?business.themecolor:'#FE5800'"

                                @click="filter=0">{{$t('zz_close_filters')}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
                <v-divider></v-divider>
                        <p class="powered-by-juzzap">powered by juZZap</p>
                <!-- Filters     -->

            </v-card-text>
        </v-card>

    </div>
</template>


<script>
import Vue from 'vue'
import { EventBus } from '@/event-bus';
import Sticky from 'vue-sticky-directive';
import {VueMasonryPlugin} from 'vue-masonry';
import { Cropper } from 'vue-advanced-cropper';
import AppBar from '@/components/AppBar.vue';
import ordercomponent from '@/components/OrderComponent.vue';
//import VeeValidate from "vee-validate";
//Vue.use(VeeValidate);

Vue.use(Sticky)
Vue.use(VueMasonryPlugin)
export default
{
    props:['business','order','isloaded','tag','countActivelang'],
    // directives: {Sticky},
    data: () => ({
        otype:'drink',
        showpayment:0,
        // savedorder:[],
        showcard:0,

        password:'',
        email:'',
        nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 20) || 'Name must be less than 20 characters',
        ],
        emailRules:
        [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],

        paymentmode:'',
        createaccount:0,
        panelAllergens:[0,1],
        orderpanel:[],
        strmsg:'',
        imgfavplus:require('@/assets/FavsplusNew.svg'),
        imgfavminus:require('@/assets/FavminusNew.svg'),
        fooditemdialog:false,
        editicon:require("@/assets/Pen-Icon-01.svg"),
        imgicon:require("@/assets/Camera-Icon-01.svg"),
        editimageicon:require("@/assets/editphotoicon.svg"),
        chillio:require("@/assets/chili-plain.svg"),

        localorder:[],
        orderdialog:0,

        orderoverlay:false,
        orderrating:0,

        itemupdateid:0,
        mainimguploading:false,
        uploadedimage:null,
        valid:true,
        fooditemshowonmenu:0,
        shw:true,
        nshw:false,
        filter:0,
        filterAllergens:0,

        drawer:null,
        itemimagedialog:false,
        addphoto: require("@/assets/addphoto.svg"),

        //filterImg:require('@/assets/filters.png'),
        //filterImg:require('@/assets/zz-filters.svg'),
        // filterImg:require('@/assets/Serpant-health-icon.svg'),

        //filterImg:require('@/assets/filters.png'),
        filterImg:require('@/assets/zz-filters.svg'),
        //filterImg:require('@/assets/Serpant-health-icon.svg'),
        allergenImg:require('@/assets/Serpant-health-icon.svg'),


        selectedAllergens:[],
        selectedAllergensName:[],

        noAllergen:0,
        panel:[],
        panelfilter:[0,1,2],
        foodview:'list',
        featureimg:require('@/assets/FaveActiveWhiteStroke.svg'),
        itemdialog:false,
        drinkitemid:0,
        fooditemid:0,
        allergensrating:0,

        ordertypes:{'types':[{'items':[]}]},
        ordercourses:{'courses':[{'items':[]}]},


        heart:require('@/assets/heart.png'),
        heartout:require('@/assets/heart-out.png'),
        //imgfavplus:require('@/assets/favplus.png'),
        //imgfavminus:require('@/assets/favminus.png'),
        favplus:require('@/assets/favplus.svg'),
        cocacolaImg:require('@/assets/cocacola2.gif'),

        overlaycocacola:false,
        orderoverlayPlain:false,
        overlayPIN:false,
        itemoverlayPlain:false,
        overlayfooditem:false,
        overlayfooditemdetail: false,
        orderoverlay:false,

        drinkitem:
        {

        "viewed":0,
        "ordered":0,
        "fimage":"",
        "image":"",
        "allergens":[],
        "measures":[],
        "units":[],
        "categories":[],
        "types":[],
        "langtransaltions":[],
        },

        fooditem:
        {
        "id":0,
        "showonmenu":0,
        "business_id":0,
        "department_id":0,
        "title":"",
        "subtitle":"",
        "description":"",
        "image":"",

        "chillispice":0,
        "created_at":"",
        "updated_at":"",
        "foodstatus":"",
        "viewed":0,
        "ordered":0,
        "fimage":"",
        "meats":[],
        "diets":[],
        "poultrys":[],
        "allergens":[],
        "courses":[],
        "drinkitems":[],
        },
        courseid:0,
        userlangcode:'',


    }),

    watch:
    {
        business:function(value)
        {
           this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }


            return value;
        },
        order:function(value)
        {
            return value;
        },

        countActivelang:function(value)
        {
            this.countActivelang1=this.countActivelang;
            return value;
        }
    },
    components: {
        Cropper,
        AppBar,
        ordercomponent
	},
    created(){
        //console.log('business data'+this.business);

        this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }

        if(this.business.hastakeaway==1 || this.business.hasdelivery==1)
        {
            this.showcard=1;
        }
        else
        {
            this.showcard=0;
        }

    },
    mounted()
    {
        let allids=localStorage.getItem('jzAllergens');
        let nAllergens=localStorage.getItem('jzNoAllergens');


        //this.$validator.localize("en", this.dictionary);
        this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }


        if(allids)
        {
            allids=JSON.parse(localStorage.getItem('jzAllergens'));
            this.selectedAllergens=allids;
            this.panel=[];
            this.panelAllergens=[0,1];

            this.setItemAllergen();
        }
    },
    computed:
    {
        ordertotal:function(){
            let total=0;
            this.order.items.forEach(function(item,inx){
                total+=parseFloat(item.qty)*parseFloat(item.price);
            })
            return parseFloat(total).toFixed(2);
        }
    },
    methods:
    {
        updateorder()
        {

            this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
        },
        backtofood()
        {
            this.orderdialog=false;
        },
        setlangcode(langcode){
              localStorage.setItem('langcode-'+this.business.id,langcode)
              this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
              if(!this.userlangcode){
                this.userlangcode="";
              }
        },
        deleteItem(drinkitemid)
        {
            if (confirm("Are you sure you want to delete this Items?"))
            {

              this.$http
                .post(this.$apidomain+"deletedrinkitem/"+drinkitemid)
                .then(res => {
                    if(res.data.success==0)
                    {

                    }
                    else if(res.data.success==1)
                    {
                        this.$router.go('/');

                    }
                    //this.drinkitems = res.data.drinkitems;
                })
                .catch(err => {
                  console.log(err.response);
                });


            }
        },

        whatsapmsg()
        {


            let th=this;




            let newstr=[];

            let whatsaapMsg="";

            th.whatsaapNumber=th.business.whatsapp;




            let total=0;

            if(th.ordercourses.courses.length>0)
            {
                let itemfound=false;
                let ordertotal=0;

                let paymentmode='';

                th.strmsg="\n\n\n*CLIENTE*\n\n";


                th.strmsg+="_"+th.order.name+"_\n\n";

                if(th.order.ordertype=='Delivery'){

                    th.strmsg+="\n"+th.order.address1;
                    th.strmsg+="\n"+th.order.address2;
                    th.strmsg+="\n"+th.order.city+", "+th.order.town;
                    th.strmsg+="\n"+th.order.zip;



                    if(th.order.paymentmode!='')
                    {
                        th.paymentmode=th.order.paymentmode;
                    }


                }

                let allAllerText="";

                let allAllergenname="";

                allAllergenname=JSON.parse(localStorage.getItem('jzAllergensName'));



                if(allAllergenname)
                {
                    allAllergenname.forEach(function(allergen,ind){



                        allAllerText+=allergen.replace('<br>',' ')+', ';
                    })

                    allAllerText=allAllerText.substr(0,allAllerText.length-1);

                }

                if(allAllerText=='')
                {
                    th.strmsg+="\n\n*ALLERGENS:* None declared  \n\n";

                }
                else
                {
                    th.strmsg+="\n\n*ALLERGENS:* "+allAllerText+" \n\n";
                }

                th.strmsg+="*Notes:* \n";


                th.strmsg+=th.order.phone;


                th.strmsg+="\n\n.............................\n";

                th.strmsg+="*"+th.business.businessName+"* \n";

                th.strmsg+=this.$domain+"businessDetails/"+th.business.businesscode+"/drink \n\n";


                th.strmsg+="*TYPO:"+th.order.ordertype+"*";
                th.strmsg+="\n.............................\n";



                th.ordercourses.courses.forEach(function(item,index){

                    if(item.items.length>0)
                    {

                        th.strmsg+="\n\n*"+item.coursename+"*\n\n";

                        item.items.forEach(function(it,ind){
                            if(it.qty>0 && it.price>0)
                            {
                                th.strmsg+=it.qty+" X "+it.title+" = "+th.business.currency.symbole+(parseFloat(it.qty)*parseFloat(it.price)).toFixed(2)+"\n";
                                ordertotal+=parseFloat(it.qty)*parseFloat(it.price);
                            }
                        })




                    }



                })

                th.strmsg+="\n..........................\n";



                th.strmsg+="*Total :"+th.business.currency.symbole+ordertotal.toFixed(2)+"*";

                th.strmsg+="\n\n";

                if(th.paymentmode!='')
                {
                    th.strmsg+="*Payment Mode* :"+th.paymentmode;


                    th.strmsg+="\n\n";

                }


                th.strmsg+="*DELIVERY CHARGES:* \n";

                if(parseFloat(ordertotal)>parseFloat(th.business.deliveryfreeorder))
                {
                    th.strmsg+="FREE This is on us, Thanks For Your Order \n";

                }
                else
                {
                    th.strmsg+="If you order just another "+th.business.currency.symbole+(parseFloat(th.business.deliveryfreeorder)-parseFloat(ordertotal)).toFixed(2)+" you will save the delivery fee.";

                }




                //th.strmsg+="\n\n powered by juZZap \n\n";





                whatsaapMsg="https://wa.me/"+th.business.whatsapp+"/?text="+encodeURIComponent(th.strmsg);

                window.location=whatsaapMsg;



            }
        },

        saveorder()
        {
            let th=this;


            let msg="";
            let response="";
            if (this.$refs.form.validate())
            {

                let fd = new FormData(document.getElementById("createorder"));

                if(th.ordercourses.courses.length>0)
                {
                    let ordertotal=0;

                    let orderitems=[];

                    let createaccount=0;

                    if(th.createaccount)
                    {
                        createaccount=1;
                    }
                    else
                    {
                        createaccount=0;
                    }

                    fd.append('createaccount',createaccount);


                    fd.append('name',th.order.name);

                    fd.append('orderid','order-'+th.business.id)

                    fd.append('businesses_id',th.business.id)

                    fd.append('paymentmode',th.order.paymentmode)

                    th.ordercourses.courses.forEach(function(item,index)
                    {

                        if(item.items.length>0)
                        {


                            item.items.forEach(function(it,ind){
                                if(it.qty>0 && it.price>0)
                                {
                                    orderitems.push({'product_type':it.type,'course_id':it.courseid,'product_name':it.title,'product_id':it.itemid,'qty':it.qty,'price':it.price,'total':parseFloat(it.qty)*parseFloat(it.price)});
                                    ordertotal+=parseFloat(it.qty)*parseFloat(it.price);
                                }
                            })

                        }



                    })

                    fd.append('ordertotal',ordertotal);

                    fd.append('addressline1',th.order.address1);

                    fd.append('addressline2',th.order.address2);

                    fd.append('city',th.order.city);

                    fd.append('town',th.order.town);

                    fd.append('zip',th.order.zip);

                    fd.append('notes',th.order.phone);

                    fd.append('orderitems',JSON.stringify(orderitems));







                }

                this.$http
                .post(this.$apidomain+"createorder", fd)
                .then(res =>
                {
                    th.msg=res.data.msg;
                    th.response=res.data.success;



                        if(res.data.success==1)
                        {
                            this.savedorder=res.data.ordermaster;
                            if(res.data.key.clientSecret!='' && this.business.paymentenabled==1)
                            {

                                this.stripe = this.business.stripapikey;
                                if(this.business.stripapikey!=''){
                                    var stripe = Stripe(this.stripe);
                                    let elements = stripe.elements();

                                    let card = elements.create("card");

                                    // Stripe injects an iframe into the DOM

                                    var style = {

                                        base: {

                                            color: "#32325d",

                                            fontFamily: 'Arial, sans-serif',

                                            fontSmoothing: "antialiased",

                                            fontSize: "16px",

                                            "::placeholder": {

                                            color: "#32325d"

                                            }

                                        },

                                        invalid: {

                                            fontFamily: 'Arial, sans-serif',

                                            color: "#fa755a",

                                            iconColor: "#fa755a"

                                        }

                                        };

                                    card.mount("#card-element", { style: style });
                                    th.showpayment=1;
                                    document.querySelector("#payment-form button").disabled = true;

                                    card.on("change", function (event)
                                    {

                                        // Disable the Pay button if there are no card details in the Element

                                        document.querySelector("#payment-form button").disabled = event.empty;

                                        document.querySelector("#card-error").textContent = event.error ? event.error.message : "";

                                    });

                                    var form = document.getElementById("payment-form");

                                    form.addEventListener("submit", function(event) {

                                    event.preventDefault();

                                    // Complete payment when the submit button is clicked

                                    th.payWithCard(stripe, card, res.data.key.clientSecret);

                                    });
                                }
                            }




                            //th.whatsapmsg()

                        }



                })
                .catch(err => {
                    //this.overlay=false;

                 console.log(err.response);
                });



            }
        },

        reduceqty(itemid,courseid)
        {
            let th=this;

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==courseid)
                {
                    //th.order.items.splice(index,1);
                    if(item.qty>0)
                    {
                        item.qty--;
                        item.total=parseFloat(item.qty)*parseFloat(item.price);

                    }
                }
            });

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();
        },
        setordertype()
        {

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();

            if(this.order.ordertype=='Delivery')
            {
                //alert('delivery');
                this.orderpanel=0;
            }
            else
            {
                this.orderpanel=1;

            }
        },
        addorderqty(itemid,courseid)
        {
            let th=this;

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==courseid)
                {
                    //th.order.items.splice(index,1);
                    item.qty++;
                    item.total=parseFloat(item.qty)*parseFloat(item.price);
                }
            });

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();
        },
        noAllergens()
        {
            this.selectedAllergens=[];
            this.panel=[];
            localStorage.setItem('jzNoAllergens',1);
            localStorage.setItem('jzAllergens','');
            this.setItemAllergen();

        },
        saveAllergens()
        {

            localStorage.setItem('jzAllergens',JSON.stringify(this.selectedAllergens));
            localStorage.setItem('jzAllergensName',JSON.stringify(this.selectedAllergensName));

            this.setItemAllergen();
            this.panel=[];
            this.panelAllergens=[0];
            this.filterAllergens=0;
        },
        addAllergens(allergenid,allergenname)
        {
            if(this.selectedAllergens.indexOf(allergenid)==-1)
            {
                this.selectedAllergens.push(allergenid);
            }else{
                this.selectedAllergens.splice(this.selectedAllergens.indexOf(allergenid),1);
            }

            if(this.selectedAllergensName.indexOf(allergenname)==-1)
            {
                this.selectedAllergensName.push(allergenname);
            }else{
                this.selectedAllergensName.splice(this.selectedAllergensName.indexOf(allergenname),1);
            }
        },
        setItemAllergen()
        {
            let th=this;

            for(let [key,value] of Object.entries(th.business.ditems))
            {

                value.forEach(function(item,ind,arr){
                    th.business.ditems[key][ind].hasallergen=0;
                    th.selectedAllergens.forEach(function(selectedallergen,index){
                        if(item.allergenids.indexOf(selectedallergen)!=-1){
                            th.business.ditems[key][ind].hasallergen=1;
                        }
                    })
                })

            }

        },
        // drinkitemdetails(drinkitemid,typeid)
        // {

        // },
        backtodialog()
        {
            this.fooditemdialog=false;
        },
        togglefav(drinkitemid,title,subtitle,img,typeid,typename,measure='')
        {
            //console.log('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img);

            //alert('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img+' typeid '+typeid+' typename '+typename);

            let th=this;
            let res=false;
            this.drinkitemid=drinkitemid;
            let ma=[];
            let it=0;
            let ip=0;
            if(measure)
            {
                ma=measure.split('|');

                if(th.order.items.length>0)
                {
                    let itemfound=false;
                    th.order.items.forEach(function(item,index)
                    {
                        if(drinkitemid==item.itemid && item.mname==ma[0])
                        {
                            th.order.items.splice(index,1);
                            //localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));
                            localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

                            itemfound=true;
                            //console.log('order minus');

                        }


                    });
                    if(!itemfound)
                    {
                        it=title+'-'+ma[0]+'-'+ma[2]+ma[3];
                        ip=ma[1];

                        // th.order.items.push({'drinkid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'typeid':typeid,'typename':typename});

                        // localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));



                        th.order.items.push({'itemid':drinkitemid,'image':img,'title':it,'subtitle':subtitle,'courseid':typeid,'course':typename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'drink','mname':ma[0]});

                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

                        this.addtoorder();

                    }
                }
                else
                {

                    // th.order.items.push({'drinkid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'typeid':typeid,'typename':typename});

                    // localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));
                    it=title+'-'+ma[0]+'-'+ma[2]+ma[3];
                    ip=ma[1];

                    th.order.items.push({'itemid':drinkitemid,'image':img,'title':it,'subtitle':subtitle,'courseid':typeid,'course':typename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'drink','mname':ma[0]});

                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));


                    this.addtoorder();
                }
            }







        },

        togglefavdrink(drinkitemid,title,subtitle,img,courseid,coursename,type,measure='')
        {



            let th=this;
            let res=false;
            //alert('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img+ ' courseid ' + courseid + ' coursename ' + coursename+' type '+type);
            //console.log('itemid' + itemid + ' courseid ' + courseid + ' coursename ' + coursename + ' price ' + price );
            this.fooditemid=drinkitemid;
            this.drinkitemid=drinkitemid;

            let ma=[];
            let it=0;
            let ip=0;
            if(measure){
                ma=measure.split('|');


                if(th.order.items.length>0)
                {
                    let itemfound=false;
                    th.order.items.forEach(function(item,index){
                        if(drinkitemid==item.itemid && courseid==item.courseid)
                        {

                            th.order.items.splice(index,1);

                            localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                            itemfound=true;
                            //console.log('order minus');
                        }

                    });
                    if(!itemfound)
                    {
                        it=title+'-'+ma[0]+'-'+ma[2]+ma[3];
                        ip=ma[1];

                        //alert(drinkitemid+','+title+','+subtitle+','+img+','+courseid+','+coursename+','+'drink')

                        th.order.items.push({'itemid':drinkitemid,'image':img,'title':it,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'drink'});
                        //res=false;
                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                        this.addtoorder();
                    }
                }
                else
                {
                    it=title+'-'+ma[0]+'-'+ma[2]+ma[3];
                    ip=ma[1];
                    //th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':0,'type':'drink'});
                            //res=false;
                    th.order.items.push({'itemid':drinkitemid,'image':img,'title':it,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'drink'});

                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                    this.addtoorder();


                }

            }

            this.drinkitemdialog=false;
            this.orderdialog=false;


        },



        togglefavfood(itemid,courseid,coursename,price,img,title,subtitle)
        {
            let th=this;
            let res=false;
            //alert('itemid' + itemid + ' courseid ' + courseid + ' coursename ' + coursename + ' price ' + price +' img '+img+' title '+title+' subtitle '+subtitle);
            this.fooditemid=itemid;
            if(th.order.items.length>0)
            {
                let itemfound=false;
                th.order.items.forEach(function(item,index){
                    if(itemid==item.itemid && courseid==item.courseid)
                    {

                        //th.order.items.pop({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                        th.order.items.splice(index,1);

                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                        itemfound=true;
                        //console.log('order minus');
                    }

                });
                if(!itemfound)
                {

                    th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':price,'type':'food'});
                    //res=false;
                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                    this.addtoorder();
                }
            }
            else
            {
                th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':price,'type':'food'});
                        //res=false;
                localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                   this.addtoorder();


            }

            this.fooditemdialog=false;
            this.orderdialog=false;
        },


        addtoorder()
        {
           // console.log('Call Addorder');
            let th=this;
            let qty=0;


            this.$http
            .get(this.$apidomain+"drinkitemorderedupdate/"+this.drinkitemid+'/plus')
            .then(res => {

            })
            .catch(err => {
            console.log(err.response);
            });

        },

        checkitemfavorite(itemid,typeid)
        {
            let th=this;
            let res=false;



                th.order.items.forEach(function(item){
                    if(itemid==item.itemid && typeid==item.courseid)
                    {
                        res=true;

                    }

                });
            return res;

        },
        checkitemfavoritedrink(itemid,typeid,mname='')
        {
            let th=this;
            let res=false;



                th.order.items.forEach(function(item){
                    if(itemid==item.itemid && typeid==item.courseid && mname==item.mname)
                    {
                        res=true;

                    }

                });
            return res;

        },
        uploadImage(event)
        {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {
                    this.mainimguploading=true;

					// create a new FileReader to read this image and convert to base64 format
					var reader = new FileReader();
					// Define a callback function to run, when FileReader finishes its job
					reader.onload = (e) => {
							// Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
							// Read image as base64 and set to imageData
							this.uploadedimage = e.target.result;
					}
					// Start the reader job - read file as a data url (base64 format)
					reader.readAsDataURL(input.files[0]);
			}
        },
        onChange({coordinates, canvas})
        {

			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
            this.image = canvas.toDataURL()
            this.mainimguploading=false;

        },
        dataURLtoFile(dataurl, filename)
        {

                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);

                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }

                return new File([u8arr], filename, {type:mime});
        },
        updateimage()
        {
            let fd = new FormData(document.getElementById("editfooditem"));

            if(this.uploadedimage!=null){
                fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
            }

            this.overlayfooditemimageupdate=true;

             this.$http
            .post(this.$apidomain+"updatedrinkItemImage/"+this.itemupdateid, fd)
            .then(res => {
                if(res.data.success==1)
                {

                    this.itemimagedialog=false;
                    this.overlayfooditemimageupdate=false;


                    // this.$router.push({name:'food',params:{tag:this.business.id,key:''}});
                    // this.$router.push({name:'businessfoodlist'});
                    this.$router.go('/');

                }
                else
                {
                    this.overlay=false;
                    this.itemimagedialog=false;

                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    alert(errmsg[0]);
                }
            })
            .catch(err => {
                    this.overlay=false;

                    console.log(err.response);
            });

        },

        updateshowitem(itemid,showitem)
        {
            //this.overlay=true;

            //  let showitem=showitem;
            //showitem= document.getElementById('showonitem-'+itemid).value;

            // console.log('show item value ' + showitem+' itemid '+itemid);

                this.$http
                .post(this.$apidomain+"updatedrinkitemshow/"+itemid,{showitem:showitem})
                .then(res => {
                    if(res.data.success==1)
                    {


                        this.$router.go('/');
                    }



                })
                .catch(err => {
                    console.log(err.response);
                    //this.overlay=false;

                });

        },
        backtomenuimage()
        {
            this.itemimagedialog=false;
            this.overlayfooditem=false;

        },
        drinkitemimage(fiid,showonmenu)
        {
            // alert(fiid);

            if(this.itemdialog)
            {
                this.itemdialog=false;
            }
            if(this.orderdialog)
            {
                this.orderdialog=false;
            }
            this.itemimagedialog=true;
            this.itemupdateid=fiid;
            this.fooditemshowonmenu=showonmenu;


        },
        backtomenu()
        {
                //this.resetfoodtem();

                this.itemdialog=false;
                this.orderdialog=false;

                //this.overlayfooditem=false;
        },
        itembacktomenu()
        {
            this.itemdialog=false;
            this.itemoverlayPlain=false;
        },
        logout()
        {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/");
            });
        },
        fooditemdetails(fiid,crid)
        {




        },
        edititem(drinkitemid)
        {
            //this.$router.push({name:'editfooditem',params:{id:itemid}});
            this.$router.push({name:'editbusinessdrinkitem',params:{id:drinkitemid,business_id:this.business.id}});

        },
        drinkitemdetails(drinkitemid,crid,type,sep)
        {
          if(sep){
            return false;
          }

            if(this.itemimagedialog==true)
            {
                this.itemdialog=false;

            }
            else
            {


                if(type=='drink')
                {

                    //this.orderoverlayPlain=true;
                    this.itemoverlayPlain=true;

                    this.$http
                    .get(this.$apidomain+"drinkitemDatanew/"+drinkitemid)
                    .then(res =>
                    {
                        this.drinkitem = res.data.item;

                        this.drinkitemid = drinkitemid;

                        this.itemdialog=true;


                        this.orderoverlayPlain=false;
                        this.itemoverlayPlain=false;




                        // this.$http
                        //     .get(this.$apidomain+"itemviewupdate/"+fiid)
                        //     .then(res => {
                        //         this.overlayfooditem=false;
                        //         this.itemdialog=true;
                        //         this.overlayPIN=false;

                        //         this.overlaycocacola=false;
                        //         this.orderoverlayPlain=false;

                        //     })
                        //     .catch(err => {
                        //     console.log(err.response);
                        // });
                        //this.itemdialog=1;
                    })
                    .catch(err => {
                        console.log(err.response);
                        this.orderoverlayPlain=false;
                        this.itemoverlayPlain=false;


                    });

                } //end if drink

                 if(type=='food')
                {

                    if(this.business.sponsored==1)
                    {
                        this.overlayPIN=true;
                        this.overlaycocacola=true;
                    }
                    else
                    {
                        this.overlayfooditem=true;
                        this.orderoverlayPlain=true;
                    }



                    this.$http
                    .get(this.$apidomain+"fooditemDatanew/"+drinkitemid+'/'+crid)
                    .then(res =>
                    {
                        this.fooditem = res.data.item;

                        this.fooditemid = drinkitemid;

                        this.courseid = crid;




                        this.$http
                            .get(this.$apidomain+"itemviewupdate/"+drinkitemid)
                            .then(res => {
                                this.overlayfooditem=false;
                                this.fooditemdialog=true;
                                this.overlayPIN=false;

                                this.overlaycocacola=false;
                                this.orderoverlayPlain=false;

                            })
                            .catch(err => {
                            console.log(err.response);
                        });
                    //this.itemdialog=1;
                    })
                    .catch(err =>
                    {
                        console.log(err.response);
                    });
                    //EventBus.$emit('fooditemclick', {'fooditemid':fooditemid,'courseid':courseid});

                }



            }
        },


        setTypes(){
            if(this.order.items.length>0)
            {
                let th=this;
                th.ordertypes={'types':[{'items':[]}]};

                th.order.items.forEach(function(item,index){
                    if(th.ordertypes.types.length==0){
                        let cr={
                            typeid:item.typeid,
                            typename: item.typename,
                            items:[]
                        };
                        cr.items.push(item);
                        th.ordertypes.types.push(cr);
                    }
                    else{
                        let typefound=false;
                        th.ordertypes.types.forEach(function(type,ind){
                            if(type.typeid==item.typeid){
                               // course.items.push($item);
                                th.ordertypes.types[ind].items.push(item);
                                typefound=true;
                            }
                        });
                        if(!typefound)
                        {
                            let cr=
                            {
                            typeid:item.typeid,
                            typename: item.typename,
                            items:[]
                            };
                            cr.items.push(item);
                            th.ordertypes.types.push(cr);
                        }
                    }
                });
            }
            else
            {
                this.ordertypes={'types':[{'items':[]}]};

            }
        },

        setordercourses(){
            if(this.order.items.length>0)
            {
                let th=this;
                th.ordercourses={'courses':[{'items':[]}]};

                th.order.items.forEach(function(item,index){
                    if(th.ordercourses.courses.length==0){
                        let cr={
                            courseid:item.courseid,
                            coursename: item.course,
                            type:item.type,
                            items:[]
                        };
                        cr.items.push(item);
                        th.ordercourses.courses.push(cr);
                    }
                    else{
                        let coursefound=false;
                        th.ordercourses.courses.forEach(function(course,ind){
                            if(course.courseid==item.courseid && course.type==item.type){
                               // course.items.push($item);
                                th.ordercourses.courses[ind].items.push(item);
                                coursefound=true;
                            }
                        });
                        if(!coursefound){
                            let cr={
                                courseid:item.courseid,
                                coursename: item.course,
                                type:item.type,
                                items:[]
                            };
                            cr.items.push(item);
                            th.ordercourses.courses.push(cr);
                        }
                    }
                });
            }
            else
            {
                this.ordercourses={'courses':[{'items':[]}]};

            }
        },
        gotoorder()
        {
            this.orderoverlay=true;
            this.orderoverlayPlain=true;
            this.overlaycocacola=true;
            //this.setTypes();
            this.setordercourses();
            //this.$router.push({'name':'order'});
            this.orderdialog=1;
            this.orderoverlay=false;
            this.orderoverlayPlain=false;
            this.overlaycocacola=false;
        },

        deleteorderitem(itemid,typeid)
        {
            let th=this;
            //alert('itemid '+itemid+' typeid '+typeid)

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==typeid)
                {
                    th.order.items.splice(index,1);

                }
            });

            localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
           // this.setTypes();
           this.setordercourses();
        }
    }
}
</script>



<style>

/* SECTION HAEDINGS  */



 .drinkmain .vue-sticky-el.top-sticky{
        width:100% !important;
        height:60px;
        margin-left: 0px;
        margin-right: 0px;

    }



.allergen-filter-icon{
    /* This appears on Food and Drink pages  */
    align-content: center;
    text-align: center;
    max-height: 30px;
    margin-top: 5px;

}

.center-center-content{
    align-content: stretch;
    vertical-align: middle;
}

.drinkmain .mid-mid{
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: auto;
    padding-right: auto;
    /* margin-left: auto; */
    /* margin-right: auto; */
    margin: auto;
}

.allergen-filter-text{
    /* This appears on Food and Drink pages  */
    font-size: 8px;
    line-height: 8px;
    margin-top: -5px;
    color: #FE5800;
    padding-top: 5px;
}

.drinkmain .pulse-banner {
  /* margin:100px; */
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  /* background: #fe5800; */
  /* cursor: pointer; */
  /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
  animation: pulse .5s;
  animation-iteration-count: 20;
}
.drinkmain .pulsex7:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}

.drinkmain .pulsex7 {
  /* margin:100px; */
  /* display: block; */
  /* width: 30px; */
  /* height: 30px; */
  border-radius: 50%;
  /* background: #fe5800; */
  /* cursor: pointer; */
  /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
  animation: pulse 2s;
  animation-iteration-count: 7;
}
.drink main .pulsex7:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}

/* SQUARE PULSE  MICRO ANIMATION */

.drinkmain .pulseBox {
  /* margin:100px; */
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  /* background: #fe5800; */
  /* cursor: pointer; */
  /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
  animation: pulse 1s;
  animation-iteration-count: 3;
}
.drinkmain .pulsex7:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}


.drinkmain .drink-title
{
    font-size:14px !important;
    line-height: 13px !important;
    padding-bottom: 2px;
    /* padding-left: 12px; */
    font-weight:800;
    color: rgb(20, 20, 20);
    text-transform:uppercase;
}

    .drinkmain .drink-title1
    {
        font-size:16px !important;
        line-height: 13px !important;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(236, 17, 17);
        text-transform:uppercase;
    }

    .drinkmain .drink-title2
    {
        font-size:16px !important;
        line-height: 13px !important;
        padding-bottom: 2px;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(20, 20, 20);
        text-transform:uppercase;
    }

    .drinkmain .drink-title3
    {
        font-size:16px !important;
        line-height: 16px !important;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(17, 174, 236);
        text-transform:uppercase;
}

.drinkmain .drink-subtitle-list{
        padding-top: 12px;
        padding-bottom: 2px;
        color: rgb(60, 60, 60);
        font-size:14px;
		font-weight: 500;
        text-transform:capitalize;
        text-align: justify;
        line-height: 14px;
        padding-left: 0px !important;

    }

.drinkmain .drink-strapline-list{
    padding-top: 12px;
    padding-bottom: 0px;
    color: rgb(60, 60, 60);
    font-size:12px;
    font-weight: 300;
    text-transform:capitalize;
    text-align: justify;
    /* font-style: italic; */
    line-height: 12px;
    padding-left: 0px !important;

}

.drink-description-list-view *{
        font-family: "Roboto", sans-serif !important;
        max-block-size: 80% !important;
        color: rgb(48, 48, 48) !important;
        padding-top: 5px !important;
        padding-bottom: 10px !important;
        padding-left: 0px !important;
        padding-right: 12px !important;
        font-size:10px !important;
        font-weight: 300 !important;
        line-height:1 !important;
        text-align: justify !important;
        margin-bottom: 20px !important;
        /* background-color: pink !important; */



    }

.drink-price-measure-list
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:10px !important;
        line-height: 13px !important;
        font-weight:300;
        text-align:left;
        color: #949494;
        text-transform:uppercase;
    }

.drink-price-unit-list
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:7px !important;
        line-height: 1 !important;
        font-weight:400;
        text-align:right;
        color: #949494;
        text-transform:lowercase;
    }

.drink-price-list
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 5px !important;
        font-size:10px !important;
        line-height: 13px !important;
        font-weight:300;
        text-align:right;
        color: #949494;
        text-transform:uppercase;
    }

.drink-price-icon-list{
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        text-align: end;
        font-size: 22px;
        color: rgb(20, 57, 220);


}

.drinkmain .cardborder-listView
    {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        position: relative;
        margin-bottom: 25px !important;

    }


.drinkmain .drink-card-list{
    border-top-left-radius: 3px !important;
    border-top-right-radius: 3px !important;
    border-bottom-left-radius: 3px !important;
    border-bottom-right-radius: 3px !important;
}

.drinkmain .drink-card-text-area{
    /* background-color: #f5de0a !important; */
    padding-top: 10px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
}


.drinkmain .cardlist-avatar{
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-left-radius: 5px !important;
    border-bottom-right-radius: 5px !important;

}

.cardlistnone
{
    border-radius:none;
    border:none !important;
    box-shadow: none !important;
    /*border-top-right-radius: 40px !important;
    border-bottom-left-radius: 40px !important;*/
}
.order-delivery-panel .v-expansion-panel::before {
 box-shadow:none;
}
.order-delivery-panel .v-expansion-panel-header{
    padding: 16px 0px;
}
.order-delivery-panel .v-expansion-panel-content__wrap {
	padding: 0px !important;
}

.drinkmain .drink-radio{
    padding-top: 0px !important;
    font-size: 10px !important;
    align-self: right !important;
}

.drinkmain .drink-favorite{
    padding-top: 5px !important;
    padding-bottom: 0px !important;
    font-size:10px !important;
    line-height:10px !important;

   }

.drinkmain .drink-radio .v-messages{
    display:none;}

.v-input--raio-group .v-messages{
    display:none;

}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
        margin-right: 10px !important;
    }
.drinkimg .v-responsive__content
{
    display: none !important;
}

/* .drinkmain .foodtitle{
    font-size:14px !important;
    line-height: 13px !important;
    font-weight:800;
    color: rgb(163, 230, 8);
    text-transform:uppercase;
} */


.foodsubtitle{
    padding-left:16px;
    padding-right: 16px;
}
.drinkmain .itemdetaildialog,.orderdetaildialog
{
    padding: 12px;
    background: #e5e5e5;
}
.drinkmain .itemdetaildialog .carddetail,.orderdetaildialog .carddetail
{
    border-top-right-radius: 50px !important;
    border-bottom-left-radius: 50px !important;

}

section-heading primary

    .drinkmain .section-heading .food-title-listView-c{
        color: #000000 !important;
        font-size: 20px !important;
        font-weight: 800 !important;
        text-align: center !important;
        padding-top: 10px;
    }

    .drinkmain .section-heading .food-subtitle-listView-c{
        padding-top: 5px;
        color: #000000 !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        text-align: center !important;
    }

    .drinkmain .section-heading .food-description-listView-c{
        color: #000000 !important;
        font-size: 10px !important;
        font-weight: 300 !important;
        text-align: center !important;
        padding-bottom: 10px;
    }
/* <This is the sticky course name that appears when you scroll down and header goes our of view */


.drink-price-section{
        position: inherit;
        bottom: 0px;
        right: 0px;

    }
.separator-drink-title-list{
        justify-content: center;
        color: #ffffff !important;
        font-size: 20px !important;
        font-weight: 600 !important;
        text-align: center !important;
        padding-top: 5px;

}

.separator-drink-subtitle-list{
        justify-content: center;
        padding-top: 1px;
        color: #ffffff !important;
        font-size: 15px !important;
        font-weight: 300 !important;
        text-align: center !important;

}
.separator-drink-card{
    border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        /* position: relative; */
        margin-top: 50px !important;
}
.invert-text-colour{
  /* color: white; */
  mix-blend-mode: difference;

}
.drink-detail-card-drink-image-h{
        /* max-height: 100%; */
        background-color: white  !important;
        /* align-content: flex-end; */
        padding-left: 15px;
        width: 100% !important;
        transform: rotate(90deg);

    }
</style>
